import React from "react";
import Swipeable from "../../../Fronts/Main/Swipeable";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Divider from "@material-ui/core/Divider";
import { permBasic } from "./checksPermmision";
import CheckboxItems, { useStylesAccs } from "./CheckBoxComponents";

export default function BasicPermissions(props) {
  const { onChange, object } = props;
  const classes = useStylesAccs();

  return (
    <div className={classes.root}>
      <Accordion expanded={true}>
        <AccordionDetails>
          <Grid item container spacing={1}>
            {permBasic?.map((item) => {
              return (
                <Grid xs={6}>
                  <CheckboxItems
                    value={object[item.name] ?? null}
                    name={item.name}
                    label={item.label}
                    onChange={onChange}
                  />
                </Grid>
              );
            })}
          </Grid>
        </AccordionDetails>
        <Divider className={classes.divider} />
      </Accordion>
      <Swipeable />
    </div>
  );
}
